<ng-template #specifyLocation>
  <h5 class="text-center card p-5">
    Please specify a location to see available stocks.
  </h5>
</ng-template>
<ng-template #loadingStocks>
  <div class="text-center" style="margin: 0 auto">
    <boma-anim-product-search></boma-anim-product-search>
    <h5>Checking Stocks</h5>
  </div>
</ng-template>

<ng-template #productIcon>
  <i class="material-icons-round mi-image rounded-thumbnail small"></i>
</ng-template>

<div class="grid" *ngIf="selectedLocation; else specifyLocation">
  <ng-container *ngIf="!loading; else loadingStocks">
    <div class="col-12 md:col-10">
      <p-table
        #dt
        [autoLayout]="true"
        [filterDelay]="300"
        [globalFilterFields]="['name', 'barcode', 'sku', 'productCode']"
        [metaKeySelection]="false"
        [scrollable]="true"
        scrollHeight="500px"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100, 250]"
        [rows]="perPage"
        [showCurrentPageReport]="true"
        [value]="newProductList"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products."
        dataKey="id"
        editMode="row"
        styleClass="p-datatable-sm p-datatable-striped"
      >
        <!-- TODO The filtering will confuse people vs searching...  -->
        <ng-template pTemplate="caption">
          <div class="flex justify-content-between">
            <div>
              <span class="p-input-icon-left">
                <i
                  class="pi pointer"
                  [ngClass]="{
                    'pi-filter-slash': filterTerm,
                    'pi-filter': !filterTerm
                  }"
                  (click)="clear(dt)"
                ></i>
                <input
                  [(ngModel)]="filterTerm"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  pInputText
                  placeholder="Filter products (name, barcode, sku or product code)"
                  type="text"
                  style="width: 370px"
                />
              </span>
            </div>
            <div class="show-all-checkbox flex align-items-center">
              <label for="showAll" class="mr-2">Hide Zero Stocks</label>
              <p-checkbox
                binary="true"
                [(ngModel)]="hideZeroStocks"
              ></p-checkbox>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 60px"></th>
            <th style="width: 60px"></th>
            <th pSortableColumn="name">
              Product <p-sortIcon field="name"></p-sortIcon>
            </th>
            <ng-container *ngIf="!searchMode">
              <th *ngIf="showStockLocations">Stock Location</th>
              <ng-container *ngIf="showQty">
                <th
                  class="text-right"
                  style="width: 100px"
                  *ngIf="!totalQtyOnly"
                  pSortableColumn="remainingStockCount"
                >
                  Remaining
                  <p-sortIcon field="remainingStockCount"></p-sortIcon>
                </th>
                <th
                  class="text-right"
                  style="width: 80px"
                  *ngIf="!totalQtyOnly"
                >
                  Reserved
                </th>
                <th class="text-right" style="width: 80px">Total</th>
              </ng-container>
              <th class="text-right" style="width: 80px" *ngIf="showPrices">
                Cost
              </th>
            </ng-container>
            <th *ngIf="showQTYInput" class="text-right" style="width: 80px">
              QTY
            </th>
            <ng-container *ngIf="showPrices">
              <th
                class="text-right"
                style="width: 80px"
                pSortableColumn="price"
              >
                Price <p-sortIcon field="price"></p-sortIcon>
              </th>

              <th class="text-right" style="width: 80px">New Price</th>
              <th class="text-right"><!--Free Confirm--></th>
              <th class="text-right" style="width: 70px">Disc %</th>

              <th class="text-right" style="width: 60px">TAX</th>
              <th class="text-right" style="width: 110px">Grand Total</th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template
          let-editing="editing"
          let-ri="rowIndex"
          let-rowData
          pTemplate="body"
          let-expanded="expanded"
        >
          <tr>
            <!-- TODO ROW EDIT INIT can probably be scrapped also highlight the row we looking at -->
            <td style="width: 60px; text-align: right">
              <button
                *ngIf="rowData?.customPricing?.tiers?.length"
                type="button"
                pButton
                pRipple
                [pRowToggler]="rowData"
                class="p-button-text p-button-rounded p-button-plain mr-2"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></button>
            </td>
            <td style="width: 60px; text-align: right">
              <img
                *ngIf="rowData.images?.length; else productIcon"
                [alt]="rowData.name"
                [src]="rowData.images | getFirstAvailableImageForSize: '60'"
                class="rounded-thumbnail small"
              />
            </td>
            <td>
              <strong>{{ rowData?.name }}</strong
              ><br />
              <ng-container *ngIf="rowData.productCode || rowData.sku"
                ><small
                  ><span *ngIf="rowData.productCode">{{
                    rowData.productCode
                  }}</span
                  ><span *ngIf="rowData.sku">{{ rowData.sku }}</span></small
                ><br
              /></ng-container>
              <small>{{ rowData.barcode }}</small>
            </td>

            <!-- TODO check role to show only to Owners -->
            <ng-container *ngIf="!rowData?.error; else notAvailableToCustomer">
              <ng-container *ngIf="!searchMode">
                <td *ngIf="showStockLocations">
                  {{ rowData.stockLocation || '--' }}
                </td>
                <ng-container *ngIf="showQty">
                  <!-- TODO WE HAVE STOCK LOCATION DATA TOO THAT WE NEED TO CONSIDER??? -->
                  <td class="text-right">
                    {{ (rowData.remainingStockCount | number) || '--' }}
                  </td>
                  <td class="text-right">
                    {{ (rowData.reservedStockCount | number) || '--' }}
                  </td>
                  <td class="text-right">
                    {{
                      (rowData.remainingStockCount + rowData.reservedStockCount
                        | number) || '--'
                    }}
                  </td>
                </ng-container>
                <td class="text-right" style="width: 60px" *ngIf="showPrices">
                  {{ (rowData.cost | currency: '' : '') || '--' }}
                </td>
              </ng-container>

              <td
                *ngIf="showQTYInput"
                [ngClass]="{
                  error: rowData.remainingStockCount < rowData.qty
                }"
                [pEditableColumnField]="'qty'"
                [pEditableColumn]="rowData"
                [pTooltip]="
                  rowData.remainingStockCount < rowData.qty && showQty
                    ? 'You have entered more stock than you have available'
                    : ''
                "
                pEditableColumn
              >
                <p-inputNumber
                  (onBlur)="onRowChange(rowData)"
                  [(ngModel)]="rowData.qty"
                  [maxFractionDigits]="0"
                  [min]="rowData.lowestMinimumQty"
                  [max]="rowData.highestMaximumQty"
                  [disabled]="showPrices && !rowData.price"
                  mode="decimal"
                  [placeholder]="returnZeroQTY ? 'TBC' : '0'"
                ></p-inputNumber>

                <small
                  *ngIf="rowData.lowestMinimumQty && rowData.highestMaximumQty"
                >
                  Min:{{ rowData.lowestMinimumQty }} Max:{{
                    rowData.highestMaximumQty
                  }}
                </small>
              </td>
            </ng-container>

            <ng-template #notAvailableToCustomer>
              <td [attr.colspan]="showStockLocations ? 6 : 5">
                {{ rowData.error }}
              </td>
            </ng-template>

            <ng-container *ngIf="showPrices">
              <ng-container *ngIf="rowData?.cheapestTier as customerTier">
                <td
                  [ngClass]="{ 'strike-out': rowData?.newPrice }"
                  class="text-right"
                  style="width: 60px"
                >
                  {{ customerTier.price | currency: '' : '' }}
                </td>
              </ng-container>
              <ng-container *ngIf="!rowData?.cheapestTier">
                <td
                  [ngClass]="{ 'strike-out': rowData?.newPrice }"
                  class="text-right"
                  style="width: 60px"
                >
                  {{ rowData.price | currency: '' : '' }}
                </td>
              </ng-container>

              <ng-container
                *permissionChecker="
                  {
                    permissions: ['update-order-item-pricing']
                  };
                  else seeNewPriceOnly
                "
              >
                <td
                  [pEditableColumnField]="'newPrice'"
                  [pEditableColumn]="rowData"
                  pEditableColumn
                  style="width: 60px"
                >
                  <p-inputNumber
                    (onBlur)="onRowChange(rowData)"
                    [(ngModel)]="rowData.newPrice"
                    [disabled]="
                      (!rowData?.remainingStockCount &&
                        rowData?.remainingStockCount < 1) ||
                      !rowData?.qty ||
                      rowData.qty === 0
                    "
                    [minFractionDigits]="2"
                    mode="decimal"
                  ></p-inputNumber>
                </td>
                <td>
                  <!-- CONFIRM FREE-->
                  <p-checkbox
                    (onChange)="onRowChange(rowData)"
                    *ngIf="rowData.newPrice === 0"
                    binary="true"
                    [(ngModel)]="rowData.free"
                    [pTooltip]="
                      rowData.free
                        ? 'WARNING! You have confirmed that this product will be free'
                        : 'Click to confirm you want this product to be FREE'
                    "
                  ></p-checkbox>
                </td>
                <td class="text-right">
                  <ng-container
                    *ngIf="rowData?.newPrice !== null && rowData?.price"
                  >
                    {{
                      ((rowData.price - rowData?.newPrice) / rowData.price) *
                        100 | number: '.2-2'
                    }}%
                  </ng-container>
                </td>
              </ng-container>
              <ng-template #seeNewPriceOnly>
                <td style="width: 60px">
                  {{ rowData.newPrice | currency: '' : '' }}
                </td>
              </ng-template>

              <td class="text-right" style="width: 60px">
                <!-- TODO Tax rates editable -->
                <!-- <input
                pInputText
                type="text"
                [(ngModel)]="rowData.taxRate"
                [disabled]="rowData.remainingStockCount < 1"
                (keyup)="onRowEditSave(rowData)"
              /> -->
                {{ rowData.taxRate | number: '1.2-2' }}%
              </td>

              <td class="text-right">
                <ng-container *ngIf="rowData?.newPrice; else normalPrice">
                  {{ rowData.qty * rowData.newPrice | currency: '' : '' }}
                </ng-container>

                <ng-template #normalPrice>
                  <td class="text-right">
                    {{ rowData.qty * rowData.price | currency: '' : '' }}
                  </td>
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData>
          <ng-container *ngFor="let item of rowData.customPricing.tiers">
            <tr
              class="p-1"
              (click)="onSelectedTier(rowData, item)"
              [ngClass]="{
                'selected-tier': rowData?.selectedTier == item
              }"
            >
              <td [attr.colspan]="showQty ? 7 : 3"><!--space holder --></td>
              <!-- <td [attr.colspan]="showPrices && showQty ? 13 : showQty ? 10 : 8"> -->

              <td>
                {{
                  item.pricingGroupName
                    ? item?.pricingGroupName
                    : 'Custom Customer Price'
                }}
              </td>
              <td colspan="2">
                Min: {{ item.minimumOrderQuantity | number }} : Max:
                {{ item.maximumOrderQuantity | number }}
              </td>
              <td class="text-right">
                {{ item.price | currency: '' : '' }}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </ng-container>
        </ng-template>

        <!-- <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="3" class="text-center">
              <div class="grid justify-content-center">
                <div class="col">
                  <boma-animation></boma-animation>
                  <h5>No product stocks found for this location</h5>
                </div>
              </div>
            </td>
          </tr>
        </ng-template> -->
      </p-table>

      <div class="text-center" *ngIf="hideZeroStocks && totalZeroStocks > 0">
        <button
          (click)="hideZeroStocks = false"
          type="button"
          pButton
          pRipple
          [label]="
            (totalZeroStocks === 1
              ? 'One product has zero stocks and was hidden'
              : totalZeroStocks + ' products has zero stocks and were hidden') +
            ', click here to show all products'
          "
          class="p-button-text p-button-primary mr-2"
        ></button>
      </div>
    </div>
    <div class="col-12 md:col-2" *ngIf="showOverView">
      <div class="card p-2">
        <h5 class="flex align-items-center justify-content-between">
          Summary
          <button
            [disabled]="!selectedItems?.length"
            (click)="clearSale()"
            class="p-button-rounded p-button-outlined p-button-danger"
            icon="pi pi-trash"
            pButton
            pRipple
            type="button"
          ></button>
        </h5>
        <table class="overview-list" *ngIf="!showPrices">
          <tr>
            <th>Qty</th>
            <th>Name</th>
          </tr>
          <tr *ngFor="let product of selectedItems">
            <td>{{ product.units }}</td>
            <td>{{ product.name }}</td>
          </tr>
        </table>

        <div class="receipt-overview" *ngIf="showPrices">
          <p *ngFor="let product of selectedItems | keyvalue">
            {{ product.value.name }} @
            <ng-container *ngIf="product.discount > 0; else noDiscount">
              <!-- TODO these on the item and send it through instead of here. -->
              {{ product?.value.paidPrice | currency: '' : '' }}
              x {{ product.value?.units }} =
              {{
                product.value?.units * product.value?.paidPrice
                  | currency: '' : ''
              }}
            </ng-container>
            <ng-template #noDiscount>
              {{ product.value.price | currency: '' : '' }}
              x {{ product.value?.units }} =
              {{
                product.value?.units * product.value?.price | currency: '' : ''
              }}
            </ng-template>

            (Tax:
            {{ product.value?.taxRate | number: '1.2-2' }}%)

            <ng-container *ngIf="product.value?.discount > 0"
              ><br />** Discount amount
              <span class="strike-out">
                {{
                  product.value?.discount * product.value.units
                    | currency: '' : ''
                }}
              </span>
              **
            </ng-container>
          </p>

          <div
            class="grid text-right mt-3 mr-2"
            *ngIf="showPrices && selectedItems?.length"
          >
            <div class="col-6 pb-0">Sub Total:</div>
            <div class="col-6 pb-0">
              {{ salesInfo.subTotal | currency: '' : '' }}
            </div>
            <ng-container *ngIf="salesInfo?.discountTotal < 0">
              <div class="col-6 pb-0">Discount:</div>
              <div class="col-6 pb-0">
                {{ salesInfo.discountTotal | currency: '' : '' }}
              </div>
            </ng-container>

            <div class="col-6 pb-0">Total Tax:</div>
            <div class="col-6 pb-0">
              {{ salesInfo.taxTotal | currency: '' : '' }}
            </div>
            <div class="col-6">Grand Total:</div>
            <div class="col-6">
              {{ salesInfo.grandTotal | currency: '' : '' }}
            </div>
            <hr />

            <div class="col-6">Total Items:</div>
            <div class="col-6">
              {{ (totalItems || 0).toString() }}
            </div>
          </div>
        </div>

        <!-- TODO SHOW CHECKOUT BUTTON -->
        <div class="col-12 mt-3" *ngIf="showCompleteButton">
          <p-button
            (click)="confirm()"
            [disabled]="submitting || totalItems === 0"
            badge="{{ (totalItems || 0).toString() }}"
            badgeClass="p-badge-primary"
            [icon]="
              submitting
                ? 'pi pi-spin pi-spinner'
                : 'material-icons-round mi-shopping-basket'
            "
            [label]="checkoutButtonText"
            styleClass="p-button-success w-full"
          ></p-button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
